import { isEmpty, isNil } from "lodash-es";
import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { useQueryParams } from "~/hook/useQueryParams";
import { useUXUYWallet } from "~/Provider/UXUYWallet";
import WalletNotConnect from "../Balance/WalletNotConnect";
import QuickBuyConfirm from "./QuickBuyConfirm";

const QuickBuyPage: React.FC = () => {
    const params = useQueryParams<{
        chain_id: string;
        contract: string;
        from_amount: string;
    }>();

    const chain_id = params.chain_id;
    const contract = params.contract;
    const from_amount = parseFloat(params.from_amount.replace("dot", "."));

    const { isConnected } = useUXUYWallet();

    if (!isConnected()) {
        return <WalletNotConnect />;
    }

    return (
        <QuickBuyConfirm
            chain_id={chain_id}
            contract={contract}
            from_amount={from_amount}
        />
    );
};

const QuickBuyPageSafeWrapper: React.FC = () => {
    const navigate = useNavigate();
    const params = useQueryParams<{
        chain_id: string;
        contract: string;
        from_amount: string;
    }>();

    const accptedKeys = ["chain_id", "contract", "from_amount"] as const;
    const isAllParamsValid = accptedKeys.every(
        (key) => !isNil(params[key]) && !isEmpty(params[key])
    );

    useEffect(() => {
        if (!isAllParamsValid) {
            navigate("/");
        }
    }, [isAllParamsValid, navigate]);

    if (isAllParamsValid) {
        return <QuickBuyPage />;
    } else {
        return null;
    }
};

export default QuickBuyPageSafeWrapper;
